import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AdminBookingModalService {
	// Signal to control modal visibility
	isOpen = signal(false);

	// Subject to notify when modal closes (for data refresh)
	private closedSubject = new Subject<void>();
	closed$ = this.closedSubject.asObservable();

	open() {
		this.isOpen.set(true);
	}

	close() {
		this.isOpen.set(false);
		this.closedSubject.next();
	}
}
